<template>
  <div class="pnl-attributes">
    <div v-for="attr in attrs" :key="attr.key" class="attr">
      <span class="name">{{ attr.name }}</span>
      <span :class="attr.cls">{{ attr.value }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PnlAttributes',
  props: ['attrs']
}
</script>
<style lang="less" scoped>
.pnl-attributes {
  display: flex;
  flex-wrap: wrap;
  padding: 0 10px 10px;
}
.attr {
  width: 48%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &:nth-child(2n) {
    margin-left: 10px;
  }
}
.name {
  color: var(--sub-text-color);
}
</style>
